import type {PictureField} from "@buildwithflux/accounts-schema";

/**
 * Runtime type guard: true when value is a PictureField discriminated
 * object rather than a legacy plain string or null.
 */
export function isPictureFieldObject(value: unknown): value is PictureField {
    if (typeof value !== "object" || value === null || !("type" in value)) return false;
    const t = (value as {type: unknown}).type;
    return t === "legacy-cdn" || t === "gravatar" || t === "url";
}
